// extracted by mini-css-extract-plugin
module.exports = {"long_text":"LongText_long_text__X9N_R"};